import type { DraftMessageId } from "@redotech/effect-api-shared/ids/definitions";
import type { DraftMessageStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/draft-message-status";
import type { DraftSendStage } from "@redotech/effect-api-shared/models/support-ticket/support-ticket-notification";

export interface DraftSendStatusPatch {
  id: DraftMessageId;
  status: DraftMessageStatus;
  sendStage: DraftSendStage | undefined;
  sendAt: string | undefined;
  sendErrorMessage?: string;
}

export function markDraftWaiting(
  draftId: DraftMessageId,
  sendAt: string,
): DraftSendStatusPatch {
  return { id: draftId, status: "SENDING", sendStage: "waiting", sendAt };
}

export function markDraftSendingStage(
  draftId: DraftMessageId,
  sendAt: string | undefined,
): DraftSendStatusPatch {
  return { id: draftId, status: "SENDING", sendStage: "sending", sendAt };
}

export function markDraftSendError(
  draftId: DraftMessageId,
  sendErrorMessage?: string,
): DraftSendStatusPatch {
  return {
    id: draftId,
    status: "ERROR",
    sendStage: "error",
    sendAt: undefined,
    sendErrorMessage,
  };
}

export function markDraftSending(
  draftId: DraftMessageId,
): DraftSendStatusPatch {
  return {
    id: draftId,
    status: "SENDING",
    sendStage: "waiting",
    sendAt: undefined,
    sendErrorMessage: undefined,
  };
}

export function restoreDraftPending(
  draftId: DraftMessageId,
): DraftSendStatusPatch {
  return {
    id: draftId,
    status: "PENDING",
    sendStage: undefined,
    sendAt: undefined,
    sendErrorMessage: undefined,
  };
}
